export default "__VITE_ASSET__b18e207c__"